import ChatLayout from './Chat.jsx';

export default ChatLayout;
